import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { getRequest } from '../../../../../core/apiRequests';
import Layout from '../../../../Layout/StandardLayout';
import Table from '../../../../Layout/Table';
import { setLoadingStatus } from '../../../../../reducers/notification';
import { getTablePaginationData, setTablePagination } from '../../../../../core/actions';

const tableName = 'SALES_TRANS_HISTORY';

const colorMap = {
  NOMATCH: {
    tc: '#ff7a7a',
    bgc: '#f9e0e0',
    txt: 'NO MATCH',
  },
  COMPLETE: {
    tc: '#7fbd31',
    bgc: '#ecf8dd',
    txt: 'MATCH',
  },
  OLD: {
    tc: '#9c9c9c',
    bgc: '#ebebeb',
    txt: 'SKIPPED',
  },
  default: { tc: '#9c9c9c', bgc: '#ebebeb', txt: 'PROCESSING' },
};

const SalesTransHistory = props => {
  const [tableData, setTableData] = useState([]);
  const [first, setFirst] = useState(true);

  useEffect(() => {
    if (props.auth.merchantId) {
      const { page, pageSize } = props.pagination;
      setLoadingStatus(true);
      (async () => {
        const reqObj = {
          params: ['salesTrigger', props.auth.merchantId, 'getSalesLog'],
          query: {
            page,
            count: pageSize,
            // selectedStores: JSON.stringify(selectedStores)
          },
        };
        const dataArr = await getRequest(reqObj);
        setLoadingStatus(false);
        const { pageInfo, results } = dataArr;
        if (pageInfo) {
          const { total, limit } = pageInfo;
          setTablePagination({ rowCount: total, pageCount: Math.ceil(total / limit) }, tableName);
        }
        if (results && results.length > 0) {
          setTableData(results);
        }
      })();
    }
  }, [props.auth.merchantId, props.pagination.page, props.pagination.pageSize]);

  const tableHeaders = useMemo(
    () => [
      {
        title: 'Transaction',
        style: { width: '1%', minWidth: '100px' },
        keyName: 'transactionDateTime',
        render: t => {
          return moment(t, 'YYYYMMDDHHmmss').format('MM/DD/YYYY');
        },
      },
      {
        title: 'Client Name',
        style: { width: '1%', paddingTop: '0px', minWidth: '110px' },
        keyName: 'client',
        render: t => t?.name || '',
      },
      {
        title: 'Product Name',
        style: { width: '5%', paddingTop: '0px', minWidth: '110px' },
        keyName: 'product',
        render: t => t?.name || '',
      },
      {
        title: 'Product Category',
        style: { width: '5%', paddingTop: '0px', minWidth: '110px' },
        keyName: 'product',
        render: t => t?.category || '',
      },
      {
        title: 'Unit Price',
        style: { width: '1%', paddingTop: '0px', minWidth: '78px' },
        keyName: 'unitPrice',
        render: t => {
          return (Number(t) || 0).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          });
        },
      },
      {
        title: 'Transaction Type',
        style: { width: '5%', paddingTop: '0px', minWidth: '110px' },
        keyName: 'transactionCodeTypeName',
      },
      {
        title: 'Automation Date',
        style: { width: '1%', paddingTop: '0px', minWidth: '78px' },
        keyName: 'automationDate',
        render: t => {
          return t ? moment(t, 'YYYYMMDD').format('MM/DD/YYYY') : '';
        },
      },
      {
        title: 'Status',
        style: { width: '1%', paddingTop: '0px', minWidth: '78px' },
        keyName: 'automationStatus',
        render: t => {
          const color = colorMap[t] || colorMap.default;
          return (
            <div className="pos-rel">
              <div
                className="w-72 h-22 flex-col-center fs-10 fw-600"
                style={{ backgroundColor: color.bgc, color: color.tc }}
              >
                <span>{color.txt}</span>
              </div>
            </div>
          );
        },
      },
    ],
    [],
  );
  const rowClickHandler = () => {
    console.log('Not implemented.');
  };
  return (
    <Layout title="Sales Log" description="View all sales transactions below" classProps="standard-width-with-sidebar">
      {tableData.length > 0 ? (
        <Table
          tableClassName="lg-table-sidebar rem-pad-width"
          data={tableData}
          tableHeaders={tableHeaders}
          searchable={false}
          paginationV2
          firstInc="View 50"
          tableName={tableName}
          onRowClick={rowClickHandler}
        />
      ) : (
        <span className="body-row flex-col-center text-light-gray">No Data Available</span>
      )}
    </Layout>
  );
};
const mapStateToProps = state => ({
  auth: state.auth,
  pagination: getTablePaginationData(state, tableName),
});
export default connect(mapStateToProps, {})(SalesTransHistory);
